// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2":"753fd4ef","45":"e1fa6100","117":"e2b72c13","451":"a7e7935e","616":"971f6f2d","822":"bafcb791"}[chunkId] + ".css";
};